import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env/environment';

interface AppConfig {
   DEBUG_HTTP: boolean,
   DEBUG_LEVEL: number,
   // añadir valores que se vayan necsitando
}

@Injectable({
   providedIn: 'root'
})
export class ExternalConfService {
   private config!: AppConfig;

   constructor(private http: HttpClient) { }

   // Se llama antes de bootstrap para cargar config.json
   async loadConfig(): Promise<void> {
      const configUrl = 'assets/conf/external-conf.json';
      this.config = await firstValueFrom(this.http.get<AppConfig>(configUrl));
   }

   // devolvemos toda la configuración
   getConfig(): AppConfig {
      return this.config;
   }

   // Métodos getters para acceder a la configuración
   get DEBUG_HTTP(): boolean {
      // this.config puede ser undefined si no se ha cargado la configuración todavía (es una promesa). Lo tenemos en cuenta
      // Si estamos en producción forzamos a false
      if (environment.production) {
         return false;
      }
      return this.config ? this.config.DEBUG_HTTP : false;
   }

   get DEBUG_LEVEL(): number {
      // this.config puede ser undefined si no se ha cargado la configuración todavía (es una promesa). Lo tenemos en cuenta
      return this.config ? this.config.DEBUG_LEVEL : 0;
   }

   // Métodos para sobreescritura de valores en tiempo de ejecución
   set DEBUG_HTTP(value: boolean) {
      this.config.DEBUG_HTTP = value;
   }

   set DEBUG_LEVEL(value: number) {
      this.config.DEBUG_LEVEL = value;
   }

   // etc...
}
